<p-card  header="Восстановление пароля" class="flex items-center justify-center p-4 cntr">

  <div class="flex flex-col gap-1 pb-8">
    <label class="lbl" for="login">Логин</label>
    <input pInputText id="login" [(ngModel)]="login">
  </div>


  <p-button (click)="resetPasswd()">Получить ссылку на восстановление пароля</p-button>

</p-card>